<template>
  <xh-filter-layout title="公司介绍管理">
    <template slot="filter">
    </template>
    <template #content >
      <div style="overflow-y: auto">
      <el-form :model="formData" ref="formData" :rules="rulesAdd" label-width="120px" label-position="right" style="margin-right: 3vw">
        <el-row>
          <el-col :span="24">
            <el-form-item label="标题：" prop="about_name" label-width="120px" style="height: 100%">
              <el-input v-model="formData.about_name"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="z-index: 0">
          <el-col :span="24">
            <el-form-item label="内容：" prop="about_content" label-width="120px" style="height: 50%">
              <Xheditor :height="630"  ref="editor" :text="formData.about_content" :fileID="formData.id"  @change="change"></Xheditor>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div style="text-align:center;">
        <el-button type="primary" @click="saveData" size="small">保存</el-button>
      </div>
      </div>
    </template>
  </xh-filter-layout>
</template>

<script>
import Xheditor from "../components/XhEditor";
import XhFilterLayout from "@/components/XhComponents/XhFilterLayout";
export default {
  name: "CompanyProfile",
  components: { Xheditor, XhFilterLayout },
  data() {
    return {
      rulesAdd: {
        about_name: [{ required: true, message: "必填项", trigger: "blur" }],
        about_content: [{ required: true, message: "必填项", trigger: "blur" }],
      },
      formData: {},
    }
  },
  methods:{
    getData() {
      let that = this;
      that.$api.post("/CompanyProfile/getData", {},
          function (res) {
            if (res.code === "200") {
              if (res.data === "") {
                  that.formData = {
                    id: that.$util.guid(),
                    about_name: "",
                    about_content: null,
                    about_type:"AT01",
                    flag: 0,//新增
                  };
              }else {
                that.formData = res.data;
                that.formData.flag = 1;//修改
              }
            }
          },
          function (res) {
            //that.$message.error("服务器异常，删除出错");
          }
      );
    },
    change(val) {
      var that = this;
      that.formData.about_content= val;
    },
    saveData() {
      let that = this;
      this.$refs.formData.validate((valid) => {
        if (valid) {
          that.$api.post("/CompanyProfile/saveData",that.formData,
              function (res) {
                if (res.code === "200" && res.msg === "true") {
                  that.$message.success("保存成功");
                  if (that.formData.flag === 0) {
                    that.getData();
                  }
                } else {
                  that.$message.warning("保存失败");
                }
              },
              function (res) {
                that.$message.error("服务异常，信息出错");
              }
          );
        } else {
          return false;
        }
      });
    },
  },
  mounted() {
    let that = this;
    that.getData();
  },
  created() {
  },
}
</script>

<style scoped>
  /deep/ .main-content{
    overflow-y: auto;
  }
</style>
